import { createApi } from "@reduxjs/toolkit/query/react";
import customBaseQuery from "../../../../utils/customBaseQuery";

export const VideoPlayerApiSlice = createApi({
  reducerPath: "videoPlayerApiSlice",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    updateVideoProgress: builder.query({
      query: (body) => ({
        url: `/progress/update`,
        method: "POST",
        body: body
      }),
      extraOptions: { service: "Progress" }
    })
  })
});

export const { useLazyUpdateVideoProgressQuery } = VideoPlayerApiSlice;
